// Timezone-safe calendar date helpers.
// NEVER use Date.toISOString() for calendar dates — it converts to UTC, which
// shifts local-midnight dates back a day for UK (BST) users.

export const toLocalYMD = (d) => {
  if (!d) return d;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Parse 'YYYY-MM-DD' as LOCAL midnight (new Date('YYYY-MM-DD') parses as UTC).
export const parseLocalDate = (v) => {
  if (v instanceof Date) return v;
  const s = String(v);
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00`) : new Date(v);
};
